import { useState } from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Form from 'epn-ui/umd/dist/components/Form';
import InputText from 'epn-ui/umd/dist/components/InputText';
import Button from 'epn-ui/umd/dist/components/Button';
import Collapse from 'epn-ui/umd/dist/components/Collapse';

// Helpers
import useI18n from '@i18n';
import { ISupportQuestionSuggestsDataAttributesFormatted } from '@api/types';
import { MIN_SEARCH_MESSAGE_LENGTH } from '../config';

export interface IAskQuestionModalProps {
    isOpen: boolean;
    onClose: (input?: string) => void;
    onSearch: (input: string) => void;
    suggests: ISupportQuestionSuggestsDataAttributesFormatted[];
    saggestsIsLoading: boolean;
    afterClose: () => void;
}

const AskQuestionModal: React.FC<IAskQuestionModalProps> = ({
    isOpen,
    onClose,
    onSearch,
    suggests = [],
    saggestsIsLoading,
    afterClose,
}) => {
    const [question, setQuestion] = useState<string>('');
    const { t } = useI18n('Support');
    const { t: tCommon } = useI18n('Common');

    return (
        <Dialog
            afterClose={() => {
                if (afterClose) {
                    afterClose();
                }

                setQuestion('');
            }}
            open={isOpen}
            onCancel={() => onClose()}
            title={t('Ask question')}
            size="lg"
        >
            <div id="support_ask_question_modal">
                <div className="mb-8 text-p1 text-blueGray-500">
                    {t(
                        'Attention! Enter only the question text or keywords. You will automatically be the options best suited to your request are offered. If you find your question in the list - you can read the answer immediately, without waiting for a response from a technical specialist.support. Otherwise, complete your question and click on the button «If you do notfound an interesting answer».',
                    )}
                </div>

                <Form
                    name="askQuestion"
                    onFieldsChange={changedFields => {
                        const messageField = changedFields.find(
                            item => Array.isArray(item.name) && item.name.includes('message'),
                        );

                        if (!messageField) return;
                        if (messageField.errors && messageField.errors.length > 0) return;
                        if (
                            messageField.value &&
                            messageField.value.length < MIN_SEARCH_MESSAGE_LENGTH
                        )
                            return;

                        onSearch(messageField.value);
                        setQuestion(messageField.value);
                    }}
                >
                    <Form.Item
                        name="message"
                        rules={[
                            {
                                required: true,
                                whitespace: true,
                                message: tCommon('Required field'),
                            },
                        ]}
                    >
                        <InputText.TextArea
                            placeholder={t('Write a message')}
                            autoSize={{ minRows: 5 }}
                        />
                    </Form.Item>
                </Form>

                <div className="mt-6">
                    {Array.isArray(suggests) &&
                        suggests.length > 0 &&
                        question.length !== 0 &&
                        !saggestsIsLoading && (
                            <Collapse items={suggests} className="bg-white text-blueGray-800" />
                        )}
                </div>

                <div className="mt-8 text-right">
                    {question.length === 0 && (
                        <Button onClick={() => onClose()}>{t('Close')}</Button>
                    )}

                    {suggests.length !== 0 ||
                        (question.length !== 0 && (
                            <Button
                                type="primary"
                                onClick={() => onClose(question)}
                                loading={saggestsIsLoading}
                            >
                                {t('Send message')}
                            </Button>
                        ))}

                    {suggests.length !== 0 && !saggestsIsLoading && question.length !== 0 && (
                        <Button onClick={() => onClose(question)}>
                            {t('Didnt find the right answer?')}
                        </Button>
                    )}
                </div>
            </div>
        </Dialog>
    );
};

export default AskQuestionModal;
